import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import css from "./Login.module.css";
import { UserContext } from "../../context/UserContext";
import { Head } from "../../utils/Head";
import { useForm } from "../../hooks/useForm";
import { Error } from "../../utils/Error";
import { Input } from "../../components/common/Input";
import { Button } from "../../components/common/Button";
import heroImage from "../../assets/hero.png";
import logoName from "../../assets/logoName.png";

export const LoginForm = () => {
  const { t } = useTranslation("home");
  const { userLogin, loading, error, signInWithGoogle } =
    useContext(UserContext);
  const [signInWithEmail, setSignInWithEmail] = useState(false);
  const navigate = useNavigate();
  const email = useForm("email");
  const password = useForm();

  async function handleSubmitLogin(event) {
    event.preventDefault();
    if (email.validate() && password.validate()) {
      userLogin(email.value, password.value);
    }
  }

  return (
    <section className={css.page}>
      <Head title="Entrar" />
      <div className={css.container}>
        <aside className={css.leftPanel} aria-hidden>
          <div className={css.leftInner}>
            <h2 className={css.leftTitle}>{t("login.title")}</h2>
            <p className={css.leftLead}>{t("login.subtitle")}</p>
            <div
              className={css.leftIllustration}
              style={{ backgroundImage: `url(${heroImage})` }}
            />
          </div>
        </aside>

        {/* Card */}
        <main className={css.cardWrap}>
          <div className={css.card}>
            <div className={css.heading} onClick={() => navigate("/home")}>
              <img src={logoName} alt="" />
            </div>

            {/* Google Sign-in */}
            <div className={css.oauthRow}>
              <button
                type="button"
                onClick={signInWithGoogle}
                className={css.googleBtn}
                aria-label="Entrar com Google"
              >
                <svg
                  className={css.googleIcon}
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fill="#4285F4"
                    d="M23.52 12.27c0-.79-.07-1.54-.2-2.27H12v4.3h6.48c-.28 1.48-1.12 2.73-2.39 3.57v2.96h3.86c2.26-2.08 3.57-5.15 3.57-8.56z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 24c3.24 0 5.96-1.08 7.94-2.94l-3.86-2.96c-1.04.7-2.37 1.11-4.08 1.11-3.14 0-5.8-2.11-6.74-4.95H1.3v3.11C3.27 21.53 7.27 24 12 24z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.26 14.26A7.39 7.39 0 0 1 4.87 12c0-.78.14-1.52.39-2.26V6.63H1.3A12.06 12.06 0 0 0 0 12c0 1.95.47 3.8 1.3 5.37l3.96-3.11z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 4.74c1.76 0 3.34.6 4.58 1.8l3.42-3.42C18 1.16 15.28 0 12 0a12 12 0 0 0-10.7 6.63l3.96 3.11C6.2 6.85 8.86 4.74 12 4.74z"
                  />
                </svg>
                <span>{t("login.google")}</span>
              </button>
            </div>

            <div className={css.divider}>
              <span>{t("login.or")}</span>
            </div>

            <div
              id="email-login-form"
              className={`${css.formArea} ${css.open}`}
            >
              <button
                type="button"
                className={css.emailToggle}
                onClick={() => setSignInWithEmail((s) => !s)}
                aria-controls="email-login-form"
              >
                {t("login.email")}
              </button>
              <form onSubmit={handleSubmitLogin} className={css.form}>
                <Input label="Email" type="email" name="email" {...email} />
                <Input
                  label={t("login.password")}
                  type="password"
                  name="password"
                  {...password}
                />

                <div className={css.actionsRow}>
                  <Link className={css.forgotLink} to="/login/recover">
                    {t("login.recover")}
                  </Link>
                  <div className={css.buttonWrap}>
                    {loading ? (
                      <Button disabled>{t("login.loading")}</Button>
                    ) : (
                      <Button type="submit">{t("login.enter")}</Button>
                    )}
                  </div>
                </div>

                <div className={css.errorWrap}>
                  <Error error={error} />
                </div>
              </form>
            </div>

            {/* <div className={css.signupRow}>
              <span>Não tem conta?</span>
              <Link to="/signup" className={css.signupLink}>
                Criar conta
              </Link>
            </div> */}
          </div>
        </main>
      </div>
    </section>
  );
};
